import React from "react";

import Icon from "../../../icon";

import { Container } from "./styles";

type IProps = any & {
  title: string;
  submittingText: string;
  isSubmitting: boolean;
  withDisable: boolean;
  color: boolean;
} & HTMLButtonElement;

const Button = ({
  title,
  submittingText,
  isSubmitting = false,
  withDisable,
  type = "submit",
  icon = "",
  ...el
}: IProps): JSX.Element => {
  const disabledAttr = withDisable
    ? { disabled: !(el.isValid && el.dirty) }
    : {};
  if (el.canShow === false) return <div />;

  return (
    <Container
      onClick={el.onClick ? el.onClick : el.handleSubmit}
      style={{ ...el.style }}
      type={type}
      {...disabledAttr}
    >
      {icon && <Icon name={icon} />}
      {isSubmitting ? submittingText : title}
    </Container>
  );
};

export default Button;
